import React from 'react';
import { makeStyles, Typography } from '@popmenu/common-ui';
import { FormattedMessage } from 'react-intl';
import RestaurantInfoStep from '../RestaurantInfoStep/RestaurantInfoStep.imports-loadable';
import SelfSignUpSiteInformation from '../SiteInformationStep/SiteInformationStep';
import SummaryStep from '../SummaryStep/SummaryStep.imports-loadable';
import SignUpStep from '../SignUpStep/SignUpStep';
import SyscoPartnerFields from './SyscoPartnerFields';
import SyscoOpcoField from './SyscoOpcoField';
import type { PlanStep } from './StarterPlan';

const useStyles = makeStyles(theme => ({
  sectionTitle: {
    marginBottom: theme.spacing(2),
  },
}));

const SyscoRestaurantInfoStep = () => {
  const classes = useStyles();
  return (
    <RestaurantInfoStep>
      <Typography variant="h6" className={classes.sectionTitle}>
        <FormattedMessage
          defaultMessage="Sysco Representative Information"
        />
      </Typography>
      <SyscoPartnerFields />
      <SyscoOpcoField />
    </RestaurantInfoStep>
  );
};

const SYSCO_STEPS: PlanStep[] = [
  { component: SyscoRestaurantInfoStep, name: 'restaurant_info_step' },
  { component: SelfSignUpSiteInformation, name: 'site_info_step' },
  { component: SummaryStep, name: 'summary_step' },
  { component: SignUpStep, name: 'sign_up_step' },
];

export default SYSCO_STEPS;
